import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=511dd442&scoped=true&"
import script from "./customer-list.vue?vue&type=script&lang=js&"
export * from "./customer-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=511dd442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511dd442",
  null
  
)

export default component.exports